export enum OnifyAPIEndpoint {
  USER_SETTINGS = '/my/settings',
  LOCALES = '/my/locales',
  MY_WORKSPACES = '/my/workspaces',
}
